import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import TopRated from './components/TopRated';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '色漫屋',
    url: 'https://baixinsh.com.cn',
    description: '色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格，支持免费在线阅读与下载，更新快速，分类清晰。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://baixinsh.com.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="色漫屋 - 海量漫画资源一站畅读 | 免费在线漫画平台"
        description="色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖热血、恋爱、悬疑、搞笑等多种题材，支持免费在线阅读与下载，更新快速，分类清晰，是漫画迷不可错过的追漫首选站点。"
        keywords="色漫屋,色漫屋在线阅读,色漫屋漫画下载,色漫屋最新更新,色漫屋免费漫画,色漫屋漫画分类,色漫屋热门推荐"
        canonicalUrl="https://baixinsh.com.cn"
        ogTitle="色漫屋 - 海量漫画资源一站畅读"
        ogDescription="色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格，支持免费在线阅读与下载。"
        structuredData={homeSchema}
      />
      <article>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
        <TopRated />
      </article>
    </>
  );
}